<template>
  <el-form :model="formData" label-width="180px">
    <el-row style="margin-top: 20px">
      <el-col :span="20">
        <el-form-item label="物件番号：">
          <el-input disabled v-model="formData.wujian_id" placeholder="物件番号"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="20">
        <el-form-item :label="$t('makeSchedule.mfgWuJianInfoEdit.mian')">
          <el-select style="width: 100%;" v-model="formData.facade_ids" :placeholder="$t('makeSchedule.mfgWuJianInfoEdit.mian')" clearable multiple
                     filterable>
            <el-option v-for="dict in facadeIdList" :key="dict.value" :label="dict.name"
                       :value="dict.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="20">
        <el-form-item :label="$t('makeSchedule.mfgWuJianInfoEdit.floor')">
          <el-select style="width: 100%;" v-model="formData.floors" :placeholder="$t('makeSchedule.mfgWuJianInfoEdit.floor')" clearable multiple
                     filterable>
            <el-option v-for="dict in floorList" :key="dict.value" :label="dict.name"
                       :value="dict.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="20">
        <el-form-item :label="$t('makeSchedule.mfgWuJianInfoEdit.setUnit')">
          <el-select style="width: 100%;" remote :remote-method="remoteMethod" :loading="remoteMethodLoading" v-model="formData.unit_nos" placeholder="单元号" clearable multiple
                     filterable>
            <el-option v-for="dict in newUnitNoList" :key="dict.unit_no" :label="dict.unit_no"
                       :value="dict.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item :label="$t('makeSchedule.mfgWuJianInfoEdit.lineSetting')"/>
      </el-col>
    </el-row>
    <el-row v-for="item in formData.lineList" :key="item.id" style="text-align: center;margin-left: 50px;height: auto">
      <el-col :span="4" class="height">
        <el-input v-model="item.cnt" style="width: 30px;height:30px;"></el-input>
        <el-checkbox v-model="item.checked" style="margin-left: 10px" size="large"/>
        <span style="margin-left: 10px;">{{ item.line_name }}</span>
      </el-col>

      <el-col :span="6" v-for="letter in item.letterList" :key="letter"  style="margin-left: 10px" class="height">
        <el-row >
          <el-col :span="2">
            <span>{{ letter.letter }}：</span>
          </el-col>
          <el-col :span="11">
            <el-input-number  min="0" v-model="letter.value" style="width: 100%" placeholder="数值"></el-input-number>
          </el-col>
          <el-col :span="11">
            <el-input style="width: 100%;margin-left: 5px" v-model="letter.remark" placeholder="备注"></el-input>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="1" class="height">
        <el-icon size="16" @click="getLetterList(item)">
          <ElIconCirclePlusFilled/>
        </el-icon>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: center;margin-top: 15px;">
        <el-button type="primary" :loading="loading" @click="saveWujianInfo" style="width: 100px;">编辑</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: "MfgWuJianInfoEdit1",
  props: {
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      formData: this.parentData,
      facadeIdList: [],
      floorList: [],
      unitNoList: [],
      newUnitNoList: [],
      remoteMethodLoading:false,
      letterList1: [{letter:'A'},{letter:'B'},{letter:'C'}],
      letterList2: [{letter:'A'},{letter:'B'},{letter:'C'}],
      letterList3: [{letter:'A'},{letter:'B'},{letter:'C'}],
      letterList4: [{letter:'A'},{letter:'B'},{letter:'C'}],
      englishLetterList1: ['A','B','C',{letter:'D'},{letter:'E'},{letter:'F'},{letter:'G'},{letter:'H'},{letter:'I'},{letter:'J'}
        ,{letter:'K'},{letter:'L'},{letter:'M'},{letter:'N'},{letter:'O'},{letter:'P'},{letter:'Q'},{letter:'R'},{letter:'S'}
        ,{letter:'T'},{letter:'U'},{letter:'V'},{letter:'W'},{letter:'X'},{letter:'Y'},{letter:'Z'}],
      englishLetterList2: ['A','B','C',{letter:'D'},{letter:'E'},{letter:'F'},{letter:'G'},{letter:'H'},{letter:'I'},{letter:'J'}
        ,{letter:'K'},{letter:'L'},{letter:'M'},{letter:'N'},{letter:'O'},{letter:'P'},{letter:'Q'},{letter:'R'},{letter:'S'}
        ,{letter:'T'},{letter:'U'},{letter:'V'},{letter:'W'},{letter:'X'},{letter:'Y'},{letter:'Z'}],
      englishLetterList3: ['A','B','C',{letter:'D'},{letter:'E'},{letter:'F'},{letter:'G'},{letter:'H'},{letter:'I'},{letter:'J'}
        ,{letter:'K'},{letter:'L'},{letter:'M'},{letter:'N'},{letter:'O'},{letter:'P'},{letter:'Q'},{letter:'R'},{letter:'S'}
        ,{letter:'T'},{letter:'U'},{letter:'V'},{letter:'W'},{letter:'X'},{letter:'Y'},{letter:'Z'}],
      englishLetterList4: ['A','B','C',{letter:'D'},{letter:'E'},{letter:'F'},{letter:'G'},{letter:'H'},{letter:'I'},{letter:'J'}
        ,{letter:'K'},{letter:'L'},{letter:'M'},{letter:'N'},{letter:'O'},{letter:'P'},{letter:'Q'},{letter:'R'},{letter:'S'}
        ,{letter:'T'},{letter:'U'},{letter:'V'},{letter:'W'},{letter:'X'},{letter:'Y'},{letter:'Z'}],
      loading: false,
    }
  }
  , methods: {
    saveWujianInfo() {
      //console.log("this.formData==",this.formData)
      for (let item of this.formData.lineList) {
        if (item.checked) {
          let bool = false;
          for (let item1 of item.letterList) {
            if (item1.value == undefined || item1.value === null) {
              continue
            } else {
              bool = true
            }
          }

          if (!bool) {
            return this.$message.error("第"+(this.formData.lineList.indexOf(item) + 1)+"条产线日产线量为空")
          }

          if (!item.cnt) {
            return this.$message.error("第"+(this.formData.lineList.indexOf(item) + 1)+"条产线顺序为空")
          }
        }
      }
      this.loading = true;
      this.formData.wuJianInfoEdit = 1;//区分 第一个还是第二个页面
      this.$axios.post('mfg/wuJianInfo/saveWujianInfo', this.formData).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        this.$message.success("编辑成功");
        this.setting.$fn.closeWindow();
        this.setting.$fn.reSearch();
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getLetterList(item) {
      let index = this.formData.lineList.indexOf(item);
      if (index == 0) {
        item.letterList.push(this.englishLetterList1[this.letterList1.length])
      }
      if (index == 1) {
        item.letterList.push(this.englishLetterList2[this.letterList2.length])
      }
      if (index == 2) {
        item.letterList.push(this.englishLetterList3[this.letterList3.length])
      }
      if (index == 3) {
        item.letterList.push(this.englishLetterList4[this.letterList4.length])
      }
    },
    getFacadeIds() {
      this.$axios.post('mfg/wuJianInfo/getFacadeIds', this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.facadeIdList = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getFloorList() {
      this.$axios.post('mfg/wuJianInfo/getFloorList', this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.floorList = res.data;
        if (this.formData.floors.length == 0) {
          for (let item of this.floorList) {
            this.formData.floors.push(item.value);
          }
        }
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getLineAll() {
      this.$axios.post('mfg/wuJianInfo/getLineAll',this.formData.wujian_id).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.formData.lineList = res.data;
        if (!this.formData.lineList[0].letterList) {
          for (let item of this.formData.lineList) {
            let index = this.formData.lineList.indexOf(item);
            if (index == 0) {
              item.letterList = this.letterList1
            }
            if (index == 1) {
              item.letterList = this.letterList2
            }
            if (index == 2) {
              item.letterList = this.letterList3
            }
            if (index == 3) {
              item.letterList = this.letterList4
            }
          }
        } else {
          for (let item of this.formData.lineList) {
            let index = this.formData.lineList.indexOf(item);
            if (index == 0) {
              this.letterList1 = item.letterList
            }
            if (index == 1) {
              this.letterList2 = item.letterList
            }
            if (index == 2) {
              this.letterList3 = item.letterList
            }
            if (index == 3) {
              this.letterList4 = item.letterList
            }
          }
        }

      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })

    },
    getUnitNoList() {
      this.$axios.post('mfg/wuJianInfo/getUnitNoList', this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.unitNoList = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    remoteMethod(query) {
      if (query) {
        this.remoteMethodLoading = true
        setTimeout(() => {
          this.remoteMethodLoading = false
          this.newUnitNoList = this.unitNoList.filter((item) => {
            return item.label.toLowerCase().includes(query.toLowerCase())
          })
        }, 200)
      } else {
        this.newUnitNoList = this.formData.unit_nos
      }
    },
  }, created() {
    this.getFacadeIds();
    this.getLineAll();
    this.getFloorList();
    //this.getUnitNoList();
  }
}
</script>

<style scoped>
.height {
  line-height: 40px;
  height: 40px;
}
</style>